import { ApckColumn } from '../../main';

/**
 * Container Info Column
 *
 * Displays container name with tooltip showing the container description
 * from container_info.yaml definitions.
 *
 * Reads container info from window._containerInfoMap which should be
 * populated by the parent view's fetchContainerInfo() call.
 *
 * Usage: { data: "name", heading: "Container", ctype: "containerinfocolumn" }
 */
export const ApckContainerInfoColumn = /*#__PURE__*/ ApckColumn.extend({
    computed: {
        displayName: function() {
            var name = this._raw || '';
            return name.replace(/\.client$/, '');
        },
        friendlyName: function() {
            var infoMap = window._containerInfoMap || {};
            var name = (this._raw || '').toLowerCase();
            var patterns = Object.keys(infoMap);
            for (var i = 0; i < patterns.length; i++) {
                if (name.indexOf(patterns[i]) !== -1) {
                    return infoMap[patterns[i]].name || '';
                }
            }
            return '';
        },
        containerDesc: function() {
            var infoMap = window._containerInfoMap || {};
            var name = (this._raw || '').toLowerCase();
            var patterns = Object.keys(infoMap);
            for (var i = 0; i < patterns.length; i++) {
                if (name.indexOf(patterns[i]) !== -1) {
                    return infoMap[patterns[i]].description || '';
                }
            }
            return '';
        }
    },
    template: `
        <apck-col-wrapper>
            <span v-if="containerDesc" v-tooltip="containerDesc">
                {{ friendlyName || displayName }} <i class="fa fa-info-circle" style="color:#8899aa;margin-left:4px;"></i>
            </span>
            <span v-else>{{ friendlyName || displayName }}</span>
        </apck-col-wrapper>
    `
});
